import { DateTime } from 'luxon';

export class StringHelper {
  public static capitalizeFirstLetter(source: string) {
    if (!source) {
      return source;
    }
    if (typeof source !== 'string') {return '';}
    return source.charAt(0).toUpperCase() + source.slice(1);
  }

  public static capitalizeFirstLettersOfPropertyChain(source: string) {
    if (!source) {
      return source;
    }
    const splits = source.split('.');
    for (let i = 0; i < splits.length; i++) {
      splits[i] = this.capitalizeFirstLetter(splits[i]);
    }
    return splits.join('.');
  }

  public static transformToTimeRepresentation(minutes: number): string {
    const hours = Math.floor(minutes/60);
    const minutesLeft = minutes % 60;
    return `${hours < 10 ? '0' : ''}${hours}:${minutesLeft < 10 ? '0': ''}${Math.trunc(minutesLeft)}`;
  }

  public static getTimeElapsed(startTime: DateTime): string {
    const endTime = DateTime.now(); // now
    const durationInMinutes = endTime.diff(startTime, 'minutes').minutes;

    return StringHelper.transformToTimeRepresentation(durationInMinutes);
  }
}
